const SectionWrapper = ({ title, children, onSubmit }) => (
  <div className="bg-white p-6 rounded-lg shadow-md mb-8 border border-blue-100">
    <h2 className="text-2xl font-semibold text-blue-700 mb-6 pb-3 border-b border-blue-200">{title}</h2>
    <div className="mb-8">{children}</div>
    {onSubmit && (
      <div className="flex justify-end">
        <button
          onClick={onSubmit}
          className="bg-blue-600 hover:bg-blue-700 font-bold py-3 px-6 rounded-lg shadow-lg transition duration-300 transform hover:scale-105"
        >
          Submit {title.split(' ')[0]} Data
        </button>
      </div>
    )}
  </div>
);

export default SectionWrapper;
